import { createSlice } from '@reduxjs/toolkit';
import { Resource } from 'model/Resource';
import { addAsyncCasesNew } from 'shared/utils/redux';
import { DemographicKind } from 'api/dto/Demographic.dto';

import {
  createDefaultDemographic,
  createDemographic,
  deleteDemographic,
  fetchDemographicList,
  fetchReportDemographicList,
  moveDemographic,
  updateDemographic,
  uploadDemographicsDry,
} from './asyncActions';
import { DemographicState, STORE_NAME } from './initialState';

export const demographicSlice = createSlice({
  name: STORE_NAME,
  initialState: DemographicState.INITIAL_DOMAIN,
  reducers: {
    clearDemographicList: (state) => {
      state.listResource = DemographicState.INITIAL_DOMAIN['listResource'];
    },
  },
  extraReducers: (builder) => {
    addAsyncCasesNew(builder, fetchDemographicList, (state, action) => {
      state.listResource = action.payload;
    });
    addAsyncCasesNew(builder, fetchReportDemographicList, (state, action) => {
      state.reportListResource = action.payload;
    });
    addAsyncCasesNew(builder, uploadDemographicsDry, (state, action) => {
      state.dryListResource = action.payload;
    });

    builder
      .addCase(createDemographic.fulfilled, (state, action) => {
        const demographicList = state.listResource.data;
        const newDemographicList = [...demographicList, action.payload];
        state.listResource = Resource.createResolvedResource({ data: newDemographicList });
      })
      .addCase(updateDemographic.fulfilled, (state, action) => {
        const demographicList = state.listResource.data;
        const index = demographicList.findIndex((item) => item.id === action.payload.id);
        const newDemographicList = demographicList.map((item, i) =>
          i === index ? action.payload : item,
        );
        state.listResource = Resource.createResolvedResource({ data: newDemographicList });
      })
      .addCase(createDefaultDemographic.fulfilled, (state, action) => {
        const demographicList = state.listResource.data;
        const newDemographicList = [...demographicList, action.payload];
        state.listResource = Resource.createResolvedResource({ data: newDemographicList });
      })
      .addCase(deleteDemographic.fulfilled, (state, action) => {
        const demographicList = state.listResource.data;
        const index = demographicList.findIndex(
          (item) => item.id === action.meta.arg.demographicId,
        );
        const newDemographicList = demographicList.filter((_, i) => i !== index);
        state.listResource = Resource.createResolvedResource({ data: newDemographicList });
      })
      .addCase(moveDemographic.pending, (state, action) => {
        const currentList = state.listResource.data;
        const newList =
          action.meta.arg.kind === DemographicKind.Date
            ? [
                ...action.meta.arg.newDemographicList,
                ...currentList.filter((d) => d.kind === DemographicKind.Choice),
              ]
            : [
                ...currentList.filter((d) => d.kind === DemographicKind.Date),
                ...action.meta.arg.newDemographicList,
              ];
        state.listResource = Resource.createResolvedResource({ data: newList });
      })
      .addCase(moveDemographic.rejected, (state, action) => {
        const currentList = state.listResource.data;
        const oldList =
          action.meta.arg.kind === DemographicKind.Date
            ? [
                ...action.meta.arg.oldDemographicList,
                ...currentList.filter((d) => d.kind === DemographicKind.Choice),
              ]
            : [
                ...currentList.filter((d) => d.kind === DemographicKind.Date),
                ...action.meta.arg.oldDemographicList,
              ];
        state.listResource = Resource.createResolvedResource({ data: oldList });
      });
  },
});

export const { clearDemographicList } = demographicSlice.actions;
